import { get, httpDelete, patch, post, put } from '../../utils/http';

export const fetchClients = ({ accountId, withLastOrderDate, searchTerm }) =>
  get(`/accounts/${accountId}/clients`, { withLastOrderDate, searchTerm });

export const addClient = ({ accountId, ...params }) => post(`/accounts/${accountId}/clients`, params);

export const fetchClient = ({ accountId, clientId }) => get(`/accounts/${accountId}/clients/${clientId}`);

export const updateClient = ({ accountId, clientId, ...params }) =>
  patch(`/accounts/${accountId}/clients/${clientId}`, params);

export const inviteClientAdmin = ({ accountId, clientId, adminId }) =>
  post(`/accounts/${accountId}/clients/${clientId}/admins/${adminId}`);

export const fetchClientBranchesAccessConfiguration = ({ accountId, clientId }) =>
  get(`/accounts/${accountId}/clients/${clientId}/branch-access`);

export const updateClientBranchesAccessConfiguration = ({ accountId, clientId, configuration }) =>
  put(`/accounts/${accountId}/clients/${clientId}/branch-access`, configuration);

export const fetchClientComments = ({ accountId, clientId }) =>
  get(`/accounts/${accountId}/clients/${clientId}/comments`);

export const addClientComment = ({ accountId, clientId, comment }) =>
  post(`/accounts/${accountId}/clients/${clientId}/comments`, { comment });

export const fetchClientInvoices = ({ accountId, clientId, from, to }) =>
  get(`/accounts/${accountId}/clients/${clientId}/invoices`, {
    accountId,
    clientId,
    from,
    to
  });

export const createInvoice = ({
  accountId,
  clientId,
  employeeSlotIds,
  branchIds,
  groupBy,
  issueDate,
  fromDate,
  toDate,
  isAttachmentsOnly = false,
  isSweepBackEnabled = false,
  splitInvoicesIntoWeeks = true
}) =>
  post(`/accounts/${accountId}/clients/${clientId}/invoices`, {
    employeeSlotIds,
    branchIds,
    groupBy,
    issueDate,
    fromDate,
    toDate,
    isAttachmentsOnly,
    isSweepBackEnabled,
    splitInvoicesIntoWeeks
  });

export const fetchClientLocations = ({ accountId, clientId }) =>
  get(`/accounts/${accountId}/clients/${clientId}/locations`);

export const fetchClientOrders = ({ accountId, clientId }) => get(`/accounts/${accountId}/clients/${clientId}/orders`);

export const addClients = ({ accountId, clients }) => post(`/accounts/${accountId}/clients/bulk`, { clients });

export const deleteClient = ({ accountId, clientId }) => httpDelete(`/accounts/${accountId}/clients/${clientId}`);

export const deleteClientComment = ({ accountId, clientId, id }) =>
  httpDelete(`/accounts/${accountId}/clients/${clientId}/comments/${id}`);
